<template>
  <div class="seelater" @click.stop="onClickSeelater" :class="{ anim_loading: isLoading }">
    <icon-base
      name="SeeLaterIcon"
      :color="inListItem ? '#FF7497' : '#FFF'"
      width="15"
      height="15"
      :is-button="false"
      :is-fill="stat"/>
    <span><span class="num" :class="{inListItem: inListItem}">{{ num }}</span></span>
  </div>
</template>

<script>
import IconBase from '@/utvStore/components/common/icon/IconBase'
import * as type from '@/utvStore/store/mutation-types'
import { mapState } from 'vuex'
import { DIALOG_STAT } from '@/CONSTS'

export default {
  name: 'SeeLaterButton',
  components: {
    IconBase
  },
  data() {
    return {
      isLoading: false,
      num: 0,
      stat: false
    }
  },
  props: {
    userId: {
      type: Number,
      default: 0
    },
    tagId: {
      type: String,
      default: ''
    },
    seelaterNum: {
      type: Number,
      default: 0
    },
    isSeelater: {
      type: Boolean,
      default: false
    },
    inListItem: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSeelater() {
      this.num = this.seelaterNum
      this.stat = this.isSeelater
    },
    tagInfo: {
      handler() {
        if(!this.isListItem) {
          this.num = this.tagInfo.seelaterNum
          this.stat = this.tagInfo.isSeelater
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      accessToken: states => states.auth.accessToken,
      tagInfo: states => states.item.tagInfo
    })
  },
  mounted() {
    this.num = this.seelaterNum
    this.stat = this.isSeelater
  },
  methods: {
    onClickSeelater(){
      if(!this.isLoading) {
        this.isLoading = true
        this.$store.dispatch(type.NOTIFY_SEELATER_ADDED, DIALOG_STAT.disable)
        this.$store.dispatch(type.SET_ITEM_SEELATER, {
          accToken: this.accessToken,
          tagId: this.tagId,
          stat: !this.stat
        }).then( res => {
          this.num = this.stat ? this.num - 1 : this.num + 1
          this.stat = !this.stat
          if( this.stat ) this.$store.dispatch(type.NOTIFY_SEELATER_ADDED, DIALOG_STAT.show)
          this.isLoading = false
        }).catch( err => {
          console.error('Error: あとで見るをセットできませんでした %O', err)
          this.isLoading = false
        })
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.seelater{
  display: flex;
  align-items: center;
  .num{
    margin-left: 4px;
    font-size: 11px;
    color: $col_white;
    &.inListItem {
      color: $col_temp_gray6;
      display: inline-block;
      padding-bottom: 5px;
    }
  }
}

.anim_loading{
  $fadeTime: 1000ms;
  $timingFunction: ease-out;
  $animName: kf_load_loop;

  animation-name: $animName;
  animation-duration:  $fadeTime;
  animation-timing-function: $timingFunction;
  animation-fill-mode: none;
  animation-iteration-count: infinite;
}
@keyframes kf_load_loop{
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 0.3;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SeeLaterButton.vue